import { Button, Copy, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Illustration } from 'src/components/selfService/features/Home/Illustration/Illustration';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { useMealCreditEntityName } from 'src/components/selfService/common/hooks/useMealCreditEntityName';
import { capitalize } from 'src/utilities/string-utils';
import { BalanceIllustrationContainer } from './Balance/BalanceIllustrationContainer';
import { IllustrationCardWrapper } from './IllustrationCardWrapper';
import { getDeviceSpaces } from './illustrationContainerUtils';

const groupOrdersIllustration = (
  <Illustration
    width="59"
    text="Save on delivery fees by placing one shared order with your team. Invite coworkers, let them add what they want, and check out for everyone."
    title="Group orders"
    mediaUrl="https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1699549517/discover_group_orders_jhpqgn.svg"
  />
);

export function IllustrationContainer(): JSX.Element {
  const { isPhone, isDesktop } = useScreenSizes();
  const { corpid } = useParams<{ corpid: string }>();
  const { push } = useHistory();
  const { value: isBalanceUiEnabled } = useFeatureFlag(
    FeatureFlag.ENABLE_BALANCE_UI
  );
  const { MEAL_CREDIT_ENTITY_NAME: entityName } = useMealCreditEntityName();

  const linesOfCreditIllustration = (
    <Illustration
      width="81"
      text="Give coworkers credits to use to order anything on Grubhub themselves. Edit your current credits, or create a new one easily."
      title={capitalize(entityName.plural)}
      mediaUrl="https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1699549518/manage_meal_credits_kwau2w.svg"
    />
  );

  if (isBalanceUiEnabled) {
    return <BalanceIllustrationContainer />;
  }

  const lineOfCreditAction = (
    <Button
      variant="primary"
      buttonSize="medium"
      block
      onClick={() => {
        push(`/corporate/management/${corpid}/lineOfCredit`);
      }}
    >
      View credits
    </Button>
  );

  const groupOrdersAction = (
    <Button
      variant="secondary"
      buttonSize="medium"
      block
      target="_blank"
      as="a"
      href="https://corporate.grubhub.com/resource/how-to-place-a-group-order-admin/?page=Resource+-+How+to+place+a+group+order+admin"
    >
      <Copy
        variant="body"
        textAlign="center"
        color="interactive"
        display="block"
      >
        Learn how
      </Copy>
    </Button>
  );

  return (
    <Flex flexDirection={!isPhone ? 'row' : 'column'}>
      <Stack
        x={getDeviceSpaces(
          { desktopSpace: 'xx-lg', tabletSpace: 'md' },
          { isDesktop, isPhone }
        )}
        y={getDeviceSpaces({ phoneSpace: 'lg' }, { isDesktop, isPhone })}
        flexBasis="50%"
      >
        <IllustrationCardWrapper
          illustration={linesOfCreditIllustration}
          action={lineOfCreditAction}
        />
      </Stack>
      <Flex flexBasis="50%">
        <IllustrationCardWrapper
          illustration={groupOrdersIllustration}
          action={groupOrdersAction}
        />
      </Flex>
    </Flex>
  );
}
